import React, { ChangeEvent, useState } from "react"

type FileUploadInputProps = {
  id?: string
  inputTitleText: string
  inputPlaceholderText: string
  acceptInputTypes?: string
  required?: boolean
  disabled?: boolean
  setSelectedFile: (value: File | null) => void
  selectedFile: File | null
  error?: string
}

const FileUploadInput: React.FC<FileUploadInputProps> = ({
  inputTitleText,
  id,
  inputPlaceholderText,
  error,
  acceptInputTypes,
  required,
  disabled,
  setSelectedFile,
  selectedFile,
}) => {
  const thisId = id ?? Math.random().toString(36).substring(2, 15)
  const [fileName, setFileName] = useState<string>(
    selectedFile ? selectedFile.name : inputPlaceholderText,
  )

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      setFileName(file.name)
      setSelectedFile(file)
    } else {
      setFileName(inputPlaceholderText)
      setSelectedFile(null)
    }
  }

  return (
    <div className="relative w-full flex flex-col items-start justify-start gap-[6px] text-left text-sm text-gray-700 font-text-md-regular1">
      <div className="self-stretch flex flex-col items-start justify-start gap-[6px]">
        {inputTitleText && (
          <div className="relative leading-[24px] font-medium">
            <label htmlFor={thisId}>
              {inputTitleText}{" "}
              <span className={required ? "text-red-500" : ""}>*</span>
            </label>
          </div>
        )}
        <input
          id={thisId}
          data-testid={id}
          className={`file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-gray-100 file:text-gray-700 file:h-full file:cursor-pointer self-stretch rounded-lg bg-base-white shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] overflow-hidden flex flex-row h-[48px] items-center justify-start gap-[8px] text-base text-gray-500 border-[1px] border-solid ${
            error ? "border-red-300" : "border-gray-300"
          } hover:cursor-pointer`}
          placeholder={fileName}
          type="file"
          accept={acceptInputTypes}
          required={required}
          disabled={disabled}
          onChange={handleFileChange}
        />
        {error && <div className="text-red-500 text-sm">{error}</div>}
      </div>
    </div>
  )
}

export default FileUploadInput
